module.exports = __webpack_public_path__ + "static/media/1.61c4c50e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/sidebars/1.jpg
// module id = 2323
// module chunks = 0